import React from 'react';
import { useViewStateStore } from '../../stores/viewState.store';
import { Button, intl } from 'ehs-react';

export function BrowserCheck(): JSX.Element {
  const [
    browserCheckState,
    supportedBrowsers,
    nextState
  ] = useViewStateStore(state => [
    state.viewStateData?.browserCheckState,
    state.viewStateData?.browserCheckSupportedBrowserDisplayNames,
    state.nextState
  ]);

  const icon =
    browserCheckState === 'UNKNOWN' ? <WarningIcon /> : <ErrorIcon />;

  let headerMsg = '';
  let bodyMsg = '';
  if (browserCheckState === 'UNSUPPORTED') {
    headerMsg = intl('virtualvisit.browser.unsupported.header');
    bodyMsg = intl('virtualvisit.browser.unsupported.body');
  } else if (browserCheckState === 'UNKNOWN') {
    headerMsg = intl('virtualvisit.browser.unknown.header');
    bodyMsg = intl('virtualvisit.browser.unknown.body');
  } else if (browserCheckState === 'UNSUPPORTED_DEVICE') {
    headerMsg = intl('virtualvisit.browser.unsupported.device.header');
    bodyMsg = intl('virtualvisit.browser.unsupported.device.body');
  }

  return (
    <>
      <div className="vvpp-content vvpp-browser-check">
        <div className="vvpp-browser-not-supported">
          <div className="vvpp-browser-not-supported-header">
            {icon}
            <div className="vvpp-browser-not-supported-header-text">
              {headerMsg}
            </div>
          </div>
          <div className="vvpp-browser-not-supported-body">
            {bodyMsg}
            {browserCheckState !== 'UNSUPPORTED_DEVICE' && (
              <div>{intl('virtualvisit.browser.supported')}</div>
            )}
          </div>
          {supportedBrowsers &&
            supportedBrowsers.length > 0 &&
            browserCheckState !== 'UNSUPPORTED_DEVICE' && (
              <ul>
                {supportedBrowsers.map(browser => (
                  <li key={browser}>{browser}</li>
                ))}
              </ul>
            )}
        </div>
      </div>
      {browserCheckState === 'UNKNOWN' && (
        <div className="vvpp-single-button">
          <Button
            id="vvpp-browser-check-next-button"
            variant="primary"
            disabled={false}
            onClick={nextState}
            text={intl('common.continue')}
          />
        </div>
      )}
    </>
  );
}

function ErrorIcon(): JSX.Element {
  return <div className="ehealthicon-cancel vvpp-browser-error-icon" />;
}

function WarningIcon(): JSX.Element {
  return <div className="vvpp-browser-warning-icon" />;
}
